import { useEffect, useState } from 'react'

export const useComponentDidMount = (delay = 0) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setTimeout(() => setMounted(true), delay)
  }, [])

  return mounted
}
